import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { CLAIM_TYPES } from "../../api/constants";
import ClaimsLog from "../../components/Claims/ClaimsLogs";
import Spinner from "../../components/SpringLoader/index";
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import PageShell from "../../components/UI/PageShell";
import { GET, newFetch } from "../../helpers/fetch";
import "./styles.css";

const Claims = ({ sites }) => {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));
  const activeSiteID = localStorage.getItem("default_site_id")
    ? Number(localStorage.getItem("default_site_id"))
    : null;
  const [claims, setClaims] = useState([]);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activeSite, setActiveSite] = useState(null);
  const [activeSiteAssociate, setActiveSiteAssociate] = useState(null);
  const [totalClaims, setTotalClaims] = useState(0);
  const [totalDeductClaims, setTotalDeductClaims] = useState(0);
  const [totalSafetyShoesClaims, setTotalSafetyShoesClaims] = useState(0);
  const [claimBalance, setClaimBalance] = useState(0);
  const [safetyShoesClaimBalance, setSafetyShoesClaimBalance] = useState(0);
  const [claimTypes, setClaimTypes] = useState([]);
  const [isAssignedClaimApprover, setIsAssignedClaimApprover] = useState(false);
  const today = new Date();
  const monthYear = today.toLocaleString("en-US", {
    month: "long",
    year: "numeric",
  });
  const year = today.toLocaleString("en-US", {
    year: "numeric",
  });
  const history = useHistory();

  const fetchAll = async () => {
    try {
      let api_path = `/claimtypes/${activeSiteID}`;
      let api_pathClaims = `/associate/claims/${
        JSON.parse(localStorage.getItem("user")).id
      }/null`;
      let claimsResponse = await newFetch(GET, api_pathClaims);
      let response = await newFetch(GET, api_path);
      if (response.success && claimsResponse.success) {
        let claimTypes = response.data;
        let claims = claimsResponse.data;
        setClaimTypes(claimTypes);
        setClaims(claims);
        setTotalClaims(claimsResponse.totalClaim);
        setTotalDeductClaims(claimsResponse.totalDeductClaim);
        setTotalSafetyShoesClaims(claimsResponse.totalSafetyShoesClaim);
        setLoading(false);
      } else {
        if (response.success) {
          ToastUtil.success(claimsResponse.message);
        } else {
          ToastUtil.error(response.message);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchClaimApprover = async () => {
    try {
      const asscoiateId = JSON.parse(localStorage.getItem("user")).id;
      let api_path = `/associate/${asscoiateId}/associateapprover/${activeSiteID}`;
      let response = await newFetch(GET, api_path);
      if (response.success) {
        setIsAssignedClaimApprover(response.success);
      } else {
        ToastUtil.error(json.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updateState = () => {
    setUpdate(!update);
  };

  useEffect(() => {
    if (activeSite?.enable_ss_claim_limit) {
      if (activeSiteAssociate?.ss_claim_limit) {
        setSafetyShoesClaimBalance(
          parseFloat(
            (
              parseFloat(activeSiteAssociate?.ss_claim_limit || 0) -
              parseFloat(totalSafetyShoesClaims)
            ).toFixed(2)
          )
        );
      }
    }

    if (activeSite?.enable_claim_limit) {
      if (activeSiteAssociate?.claim_limit) {
        if (activeSite?.enable_claim_percentage) {
          setClaimBalance(
            parseFloat(
              (
                parseFloat(activeSiteAssociate?.claim_limit || 0) -
                parseFloat(totalDeductClaims)
              ).toFixed(2)
            )
          );
        } else {
          setClaimBalance(
            parseFloat(
              (
                parseFloat(activeSiteAssociate?.claim_limit || 0) -
                parseFloat(totalClaims)
              ).toFixed(2)
            )
          );
        }
      }
    }
  }, [
    activeSite,
    activeSiteAssociate,
    totalClaims,
    totalDeductClaims,
    totalSafetyShoesClaims,
  ]);

  useEffect(() => {
    fetchClaimApprover();
    fetchAll();
  }, [update]);

  useEffect(() => {
    if (sites.length > 0) {
      const filterSite = sites.find((item) => item.id === activeSiteID);
      setActiveSite(filterSite);
    }
  }, [sites]);

  useEffect(() => {
    const fetchUser = async () => {
      let api_path = "/associate/aboutme";
      let response = await newFetch(GET, api_path);

      if (response.success) {
        if (response.data?.site_associates) {
          const filterSiteAssociate = response.data?.site_associates.find(
            (item) => item.site_id === activeSiteID
          );
          setActiveSiteAssociate(filterSiteAssociate);
        }
      }
    };

    if (user) {
      fetchUser();
    }
  }, []);

  return (
    <PageShell
      title={t("Claims")}
      eyebrow="Finance"
      description="Submit expenses and monitor your available claim balances."
      actions={
        !loading && isAssignedClaimApprover ? (
          <button
            onClick={() => history.push("/claimsadd")}
            className="btn btn-design btn-brand"
          >
            <i className="fas fa-plus mr-2" aria-hidden="true" />
            {t("Submit Claim")}
          </button>
        ) : null
      }
    >
        {!loading ? (
          isAssignedClaimApprover ? (
            <>
              <div className="portal-metric-grid">
              {claimTypes.find(
                (item) => item.id === CLAIM_TYPES.STAFF_PURCHASE
              ) &&
                activeSite?.enable_claim_limit && (
                  <div className="portal-metric-card">
                    <span className="font-12">
                      {t("Staff Purchase Claim Balance")} ({monthYear})
                    </span>
                    <strong>{claimBalance.toFixed(2)} SGD</strong>
                    <small>Available balance</small>
                  </div>
                )}

              {activeSite?.enable_ss_claim_limit &&
                claimTypes.find(
                  (item) => item.id === CLAIM_TYPES.SAFETY_SHOES
                ) && (
                  <>
                    <div className="portal-metric-card">
                      <span className="font-12">
                        {t("Safety Shoes Claim Balance")} ({year})
                      </span>
                      <strong>{safetyShoesClaimBalance.toFixed(2)} SGD</strong>
                      <small>Available balance</small>
                    </div>

                    <div className="portal-metric-card">
                      <span className="font-12">
                        {t("Total Safety Shoes Claims")} ({year})
                      </span>
                      <strong>{totalSafetyShoesClaims.toFixed(2)} SGD</strong>
                      <small>Used this year</small>
                    </div>
                  </>
                )}

              {claimTypes.find(
                (item) => item.id === CLAIM_TYPES.STAFF_PURCHASE
              ) &&
                activeSite?.enable_claim_limit && (
                  <div className="portal-metric-card">
                    <span className="font-12">
                      {t("Total Staff Purchase Claims")} ({monthYear})
                    </span>
                    <strong>
                      {activeSite?.enable_claim_percentage
                        ? totalDeductClaims.toFixed(2)
                        : totalClaims}{" "}
                      SGD
                    </strong>
                    <small>Used this month</small>
                  </div>
                )}
              </div>

              <div className="portal-content-card" id="accordionFAQs">
                {loading ? (
                  <Spinner />
                ) : (
                  <React.Fragment>
                    <ClaimsLog
                      claims={claims}
                      updateState={updateState}
                      activeSite={activeSite}
                    />
                  </React.Fragment>
                )}
              </div>
            </>
          ) : (
            <div className="portal-empty-state">
              <span className="portal-empty-state__icon" aria-hidden="true">
                <i className="fas fa-user-shield" />
              </span>
              <h2>Claim access unavailable</h2>
              <p>
              {t(
                "Sorry, you cannot use the claim because no approver has been assigned. Please contact the admin to assign one for you."
              )}
              </p>
            </div>
          )
        ) : (
          <Spinner />
        )}
    </PageShell>
  );
};

export default Claims;
